import * as React from 'react'
import clsx from 'clsx'

import styles from './Trustpilot.module.css'

const PROFILE_HREF = 'https://fr.trustpilot.com/review/ulule.com'

export type TrustpilotProps = {
  /** Placement only — the row owns its own look. */
  className?: string
}

/** Filled star: both the rating stars and the one leading the Trustpilot wordmark. */
function Star(): React.ReactElement {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
  )
}

/**
 * Trustpilot rating row: the "Excellent" grade, five stars, and a link to Ulule's public profile.
 * Shared by the static pages that end a section on it.
 *
 * FIXME(trustpilot): this rating row is static. Make it dynamic by rendering the live Duvet
 * `<Trustpilot>` widget instead — it can't be SSR'd here (it imports `@owl-nest/models`, which
 * reads UFE config at module-eval time, absent in the standalone prerender), so it must be mounted
 * client-only / lazily. The real widget already runs in the client-mounted footer.
 */
export function Trustpilot({ className }: TrustpilotProps): React.ReactElement {
  return (
    <div className={clsx(styles.trust, className)}>
      <b className={styles.trust__label}>Excellent</b>
      <span className={styles.trust__stars} aria-hidden="true">
        {[0, 1, 2, 3, 4].map((index) => (
          <span key={index} className={styles.trust__star}>
            <Star />
          </span>
        ))}
      </span>
      <a className={styles.trust__link} href={PROFILE_HREF} target="_blank" rel="noopener noreferrer">
        <span className={styles.trust__logoStar}>
          <Star />
        </span>
        Trustpilot
      </a>
    </div>
  )
}
